var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconChatBubbleGraphics = function SvgIconChatBubbleGraphics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1985",
    fill: "#4b4b4b",
    d: "M0 0h39.73v33.527H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5672"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1976",
    fill: "#fff",
    opacity: 0.8,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5671"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5670",
    clipPath: "url(#a)",
    fill: "#4b4b4b",
    transform: "translate(5.135 8.236)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4575",
    d: "M19.863 13.925a2.354 2.354 0 1 0 1.664.689 2.354 2.354 0 0 0-1.664-.689"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4576",
    d: "M39.284 12.878C37.371 5.529 29.391 0 19.862 0a24.1 24.1 0 0 0-1.686.063 24.027 24.027 0 0 0-2.744.35C6.607 2.069 0 8.551 0 16.279a14.025 14.025 0 0 0 2.388 7.755L.1 30.934a1.975 1.975 0 0 0 2.5 2.492l8.11-2.693a23.529 23.529 0 0 0 9.155 1.825c10.952 0 19.862-7.3 19.862-16.279 0-.223-.01-.443-.021-.664a10.712 10.712 0 0 0-.419-2.737m-2.307 3.4c0 7.462-7.677 13.534-17.115 13.534a20.652 20.652 0 0 1-8.516-1.8 1.378 1.378 0 0 0-1-.054l-7.158 2.378 2.02-6.088a1.373 1.373 0 0 0-.194-1.24 11.4 11.4 0 0 1-2.27-6.728c0-7.462 7.678-13.534 17.115-13.534s17.116 6.071 17.116 13.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4577",
    d: "M11.731 13.925a2.354 2.354 0 1 0 1.664.689 2.354 2.354 0 0 0-1.664-.689"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4578",
    d: "M27.994 13.925a2.354 2.354 0 1 0 1.664.689 2.354 2.354 0 0 0-1.664-.689"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChatBubbleGraphics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-chat-bubble-graphics.6dea5c6c.svg";
export { ForwardRef as ReactComponent };